import type { MapBody } from '@shared/mapDefinitions.js';

const def: MapBody<'events'> = {
  minZoom: 0,
  zIndex: 8,
  attribution: [],
};

export default def;
